import { A02, A02Input, A02Output } from 'api/U012';
import { useCallback, useState } from 'react';

type SendInquiryDoRequest = (param: {
  input: A02Input;
  onSuccess?: () => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => void;

export function useSendInquiry(): [SendInquiryDoRequest, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [err, setError] = useState<Error | null>(null);

  const sendInquiry = async (param: {
    input: A02Input;
    cancellation?: AbortSignal;
  }): Promise<A02Output> => {
    return await A02(param.input, param.cancellation);
  };

  const doRequest = useCallback<SendInquiryDoRequest>(
    async ({ input, cancellation, onSuccess, onError }) => {
      setLoading(true);
      setError(null);
      try {
        await sendInquiry({ input, cancellation });
        onSuccess?.();
      } catch (err) {
        const flooredError = err instanceof Error ? err : new Error(`unknown error. ${err}`);
        onError?.(flooredError);
        setError(flooredError);
      } finally {
        setLoading(false);
      }
    },
    [sendInquiry, setLoading, setError]
  );

  return [doRequest, loading, err];
}
